import { createContext, FC, useCallback, useContext, useEffect, useState } from 'react'
import { WithChildren } from '../../../../_metronic/helpers'
import { Licenca } from '../../../services/models'
import { getSituacaoLicenca } from '../../../services/Renovacao'
import { useAuth } from '../../auth'

type LicencaContextProps = {
  licenca?: Licenca | null
  carregando: boolean
  recarregar: () => Promise<void>
}

const LicencaContext = createContext<LicencaContextProps>({
  carregando: true,
  recarregar: async () => {},
})

export const useLicenca = () => useContext(LicencaContext)

// Situação da licença (vencida, dias restantes, exibir aviso) calculada pelo backend
export const LicencaProvider: FC<WithChildren> = ({ children }) => {
  const { auth } = useAuth()
  const [licenca, setLicenca] = useState<Licenca | null>()
  const [carregando, setCarregando] = useState(true)

  const recarregar = useCallback(async () => {
    try {
      setLicenca(await getSituacaoLicenca())
    } catch (error) {
      console.error(error)
    } finally {
      setCarregando(false)
    }
  }, [])

  useEffect(() => {
    if (!auth?.api_token) return
    recarregar()
  }, [auth?.api_token, recarregar])

  return (
    <LicencaContext.Provider value={{ licenca, carregando, recarregar }}>{children}</LicencaContext.Provider>
  )
}
